
function InitDataSources(dataSources) {
  let obj = {}
  if (dataSources) {
    for (const ds of dataSources) {
      obj[ds.$ID] = () => import('./DataSourceModel')
    }
  }
  return obj
}

export default InitDataSources